import ChatInner from '../components/Message/ChatInner';
import Page from "../layout/components/Page";
import LoadingIndicator from "../components/Common/LoadingIndicator";
import { useEffect } from "react";
import { MessageItem } from "../components/Message/MessageItem";
import { useFetchMessageThread } from "../hooks/message/useFetchMessageThread";
import { useMessageList } from '../context/MessageListContext';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from '../components/ErrorFallback/ErrorFallback';
import { handleApiError } from '../helpers';

const MessagePage = () => {
  const { error: messageListError, messageList, fetching: fetchingList, fetchMessageList } = useMessageList();
  const { messageThread, group_key, makeActive, fetching: fetchingThread } = useFetchMessageThread();

  useEffect(() => {
    fetchMessageList(false);
  }, [fetchMessageList]);

  return (
    <Page title="Messages" icon="bi-envelope">
      {messageListError ? (
        <div className="card">
          <div className="d-flex justify-content-center align-item-center card-body">
            <div className="text-center pt-20 pb-20">
              <i className="bi bi-folder" style={{ fontSize: "3.5em" }}></i>
              <p className="text-muted ms-20p me-20p pt-3 pb-3">
                {messageListError.message === "Network Error"
                  ? "Network Error. Please ensure you have an internet connection, and try again."
                  : handleApiError(messageListError)}
              </p>
              <button
                onClick={() => fetchMessageList()}
                className="btn  btn-bg-light btn-active-color-primary btn-sm me-1 text-muted fw-bold"
              >
                <span className="fw-bolder">Refresh</span>
              </button>
            </div>
          </div>
        </div>
      ) : fetchingList ? (
        <div className="card vh-100 p-5">
          <LoadingIndicator message="" />
        </div>
      ) : messageList.length >= 1 ? (
        <div className="d-flex flex-column flex-lg-row">
          <div className="flex-column flex-lg-row-auto w-100 w-lg-300px w-xl-400px mb-10 mb-lg-0">
            <div className="card card-flush">
              <div className="card-body pt-5" id="kt_chat_contacts_body">
                <div
                  className="scroll-y me-n5 pe-5 h-200px h-lg-auto"
                  data-kt-scroll="true"
                  data-kt-scroll-activate="{default: false, lg: true}"
                  data-kt-scroll-max-height="auto"
                  data-kt-scroll-dependencies="#kt_header, #kt_toolbar, #kt_footer, #kt_chat_contacts_header"
                  data-kt-scroll-wrappers="#kt_content, #kt_chat_contacts_body"
                  data-kt-scroll-offset="0px"
                >
                  {messageList &&
                    messageList.length >= 1 &&
                    messageList.map((message) => {
                      return (
                        <div key={message.id}>
                          <MessageItem
                            message={message}
                            makeActive={makeActive}
                          />
                          <div className="separator separator-dashed"></div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
          <div className="flex-lg-row-fluid ms-lg-7 ms-xl-10">
            {fetchingThread ? (
              <div className="card p-5">
                <LoadingIndicator message="" />
              </div>
            ) : (
              <div className="card" id="kt_chat_messenger">
                <div
                  className="card-header"
                  style={{ minHeight: "50px" }}
                  id="kt_chat_messenger_header"
                >
                  <div className="card-title">
                    <div className="symbol-group symbol-hover"></div>
                    <div className="d-flex justify-content-center flex-column me-3">
                      <span className="fs-6">
                        {messageThread[0]?.title || ""}
                      </span>
                    </div>
                  </div>
                </div>
                {group_key && messageThread.length > 1 ? (
                  <ErrorBoundary FallbackComponent={ErrorFallback}>
                    <ChatInner />
                  </ErrorBoundary>
                ) : (
                  <div className="d-flex justify-content-center align-item-center">
                    <div className="text-center pt-20 pb-20">
                      <i
                        className="bi bi-envelope"
                        style={{ fontSize: "3.5em" }}
                      ></i>
                      <p className="text-muted ms-20p me-20p pt-3 pb-3">
                        Select an item to read
                      </p>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-item-center">
          <div className="text-center pt-20 pb-20">
            <i className="bi bi-folder" style={{ fontSize: "3.5em" }}></i>
            <p className="text-muted ms-20p me-20p pt-3 pb-3">
              You have no conversations
            </p>
          </div>
        </div>
      )}
    </Page>
  );
};

export default MessagePage;
